// Shared, read-only local search for the authenticated workspace.
// Never calls an API or stores/transmits a query.
export const normaliseSearch=value=>String(value??'')
  .normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim()
  .replace(/\s+/g,' ');

export const matchesSearch=(fields,query)=>{
  const tokens=normaliseSearch(query).split(' ').filter(Boolean);
  if(!tokens.length)return true;
  const text=normaliseSearch(fields.filter(value=>value!=null && value!=='').flat().join(' '));
  return tokens.every(token=>text.includes(token));
};

export const transactionSearchFields=row=>[
  row.payee,row.category,row.account,row.person,row.notes,row.description,
  row.type,row.status,row.status==='posted'?'completed':'pending',
  row.date,row.amount,
  Array.isArray(row.tags)?row.tags:row.tags
];

const kinds=[
  {key:'transactions',name:'Transactions',singular:'Transaction',path:'/transactions',
    title:row=>row.payee||row.category||'Transaction',
    detail:row=>[row.category,row.amount!=null?String(row.amount):'',row.date].filter(Boolean).join(' · '),
    fields:transactionSearchFields,limit:5},
  {key:'people',name:'People',singular:'Person',path:'/people',
    title:row=>row.name||'Person',detail:row=>row.shortName||row.contact||'',
    fields:row=>[row.name,row.shortName,row.contact,row.notes],limit:3},
  {key:'recurringRules',name:'Recurring',singular:'Recurring rule',path:'/recurring',
    title:row=>row.name||'Recurring rule',
    detail:row=>[row.category,row.frequency,row.amount].filter(x=>x!=null).join(' · '),
    fields:row=>[row.name,row.category,row.frequency,row.payee,row.person,row.notes,row.amount,row.type],limit:3},
  {key:'budgets',name:'Budgets',singular:'Budget',path:'/budgets',
    title:row=>row.category||row.name||'Budget',
    detail:row=>[row.period,row.amount??row.limit].filter(x=>x!=null).join(' · '),
    fields:row=>[row.category,row.name,row.period,row.amount,row.limit],limit:3},
  {key:'categories',name:'Categories',singular:'Category',path:'/categories',
    title:row=>row.name||'Category',detail:row=>row.type||'',
    fields:row=>[row.name,row.type],limit:3}
];

const relevance=(title,fields,term)=>{
  const t=normaliseSearch(title),q=normaliseSearch(term);
  return t===q?0:t.startsWith(q)?1:t.includes(q)?2:3;
};

export function searchWorkspace(state,rawQuery){
  const query=String(rawQuery??'').trim();
  if(!query)return {query:'',total:0,groups:[]};
  const groups=kinds.map(kind=>{
    const matched=(state[kind.key]||[]).filter(row=>row&&!row.isDeleted&&
      matchesSearch(kind.fields(row),query));
    const rows=matched.map((row,index)=>({...row,_index:index}))
      .sort((a,b)=>relevance(kind.title(a),kind.fields(a),query)-
        relevance(kind.title(b),kind.fields(b),query)||a._index-b._index)
      .slice(0,kind.limit).map(row=>({
        id:row.id,
        title:String(kind.title(row)),
        detail:String(kind.detail(row)),
        kind:kind.singular,
        path:kind.path+'?search='+encodeURIComponent(query)
      }));
    return {name:kind.name,count:matched.length,rows};
  }).filter(group=>group.count>0);
  return {query,total:groups.reduce((n,g)=>n+g.count,0),groups};
}